import Route from '@ember/routing/route';

export default class DestinationSettingsPersonalRoute extends Route {}
